var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"numberScroll",style:(_vm.numStyle)},_vm._l((_vm.numberToArray),function(item,index){return _c('div',{key:index,staticClass:"screenMini",style:(_vm.minStyle)},[_c('div',{style:(_vm.reStyle(item))},_vm._l((_vm.numberBox),function(v,i){return _c('div',{key:i,style:(_vm.minDivStyle)},[_vm._v(_vm._s(v))])}),0)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }